import { Editor, Element, Range, Text, Transforms } from 'slate';
import { ReactEditor } from 'slate-react';

import { isElementWithType } from '../../helpers/node-filter';

const isNonNavigableTextNode = (node) => Text.isText(node) && node.text === '';

interface NormalizePluginProps {
  type: string;
}

export const withInsertTextInsideInlineElement =
  (type: string) =>
  <T extends ReactEditor>(editor: T) => {
    const { insertText } = editor;

    editor.insertText = (text: string) => {
      const { selection, marks } = editor;

      if (selection) {
        // If the cursor is at the end of an inline that's not ELEMENT, move it outside of
        // the inline before inserting
        if (Range.isCollapsed(selection)) {
          const inline = Editor.above(editor, {
            match: (n: any) => Editor.isInline(editor, n) && isElementWithType(n, type),
            mode: 'highest',
          });

          if (!inline) {
            insertText(text);
            return;
          }
        }

        if (marks) {
          const node = { text, ...marks };
          Transforms.insertNodes(editor, node as any);
          return;
        }
        editor.marks = null;
      }
      insertText(text);
    };
    return editor;
  };

export const withNormalizeElementPlugin =
  ({ type }: NormalizePluginProps) =>
  <T extends ReactEditor>(editor: T) => {
    const { normalizeNode } = withInsertTextInsideInlineElement(type)(editor);

    editor.normalizeNode = (entry) => {
      const [node, path] = entry as [any, any[]];

      if (
        isElementWithType(node, type) &&
        Element.isElement(node) &&
        node?.children?.length === 1 &&
        isNonNavigableTextNode(node.children[0])
      ) {
        Transforms.delete(editor, { at: path });
        return;
      }

      normalizeNode(entry);
    };

    return editor;
  };
